import { memo } from 'react';
import { cn } from '@/lib/utils';
import { ILeadTypeBadgeProps, TLeadType } from '@/@types/leads';

const leadTypeConfig: Record<TLeadType, { label: string; className: string }> = {
  buyer: {
    label: 'Buyer',
    className: 'bg-[#8B5CF6]/20 text-[#8B5CF6] border-[#8B5CF6]',
  },
  seller: {
    label: 'Seller',
    className: 'bg-[#06B6D4]/20 text-[#06B6D4] border-[#06B6D4]',
  },
  investor: {
    label: 'Investor',
    className: 'bg-[#EC4899]/20 text-[#EC4899] border-[#EC4899]',
  },
  renter: {
    label: 'Renter',
    className: 'bg-[#84CC16]/20 text-[#06B6D4] border-[#84CC16]',
  },
  landlord: {
    label: 'Landlord',
    className: 'bg-[#10B981]/20 text-[#10B981] border-[#10B981]',
  },
};

export const LeadTypeBadge = memo(function LeadTypeBadge({
  leadType,
  size = 'md',
}: ILeadTypeBadgeProps) {
  const config = leadTypeConfig[leadType];

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded border font-medium',
        config.className,
        size === 'sm' ? 'min-w-[68px] px-2.5 py-1 text-xs' : 'min-w-[80px] px-3 py-1.5 text-sm'
      )}
    >
      {config.label}
    </span>
  );
});
